import React, { useState, useEffect } from "react";
import {
  Box,
  Flex,
  Select,
  Input,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Text,
  Link,
  Button,
  Stack,
  IconButton,
  useToast,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  useDisclosure,
} from "@chakra-ui/react";
import { DeleteIcon } from "@chakra-ui/icons";
import axios from "axios";
import { BASE_URL } from "../../../../Globalapi/Globalapi";

const Return_Table = () => {
  const [data, setData] = useState([]);
  const [books, setBooks] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [issueIdToDelete, setIssueIdToDelete] = useState(null);
  const [searchName, setSearchName] = useState(""); // For searching names
  const [selectedBook, setSelectedBook] = useState(""); // For filtering by book
  const toast = useToast();
  const { isOpen, onOpen, onClose } = useDisclosure();

  const schoolId = sessionStorage.getItem("school_id");
  const apiUrl =
    `${BASE_URL}/admin/library/issues/list_issue.php`;
  console.log("API URL: ", apiUrl);

  const deleteApiUrl =
    `${BASE_URL}/admin/library/issues/delete_issue.php`;

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await axios.get(apiUrl, {
          params: { school_id: schoolId },
        });
        console.log("Fetched issues: ", response);

        if (response.data.success) {
          // Filter the issues to include only those with status "Returned"
          const returnedIssues = response.data.data.filter(
            (item) => item.status === "Returned"
          );
          setData(returnedIssues);
          console.log("Filtered returned issues: ", returnedIssues);
        } else {
          console.error(response.data.message);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [schoolId]);

  useEffect(() => {
    const fetchBooks = async () => {
      try {
        const response = await fetch(
          `${BASE_URL}/admin/library/books/list_books.php?school_id=${schoolId}`
        );
        const data = await response.json();
        console.log("Fetched books: ", data);

        if (data.success) {
          setBooks(data.data);
          console.log("books",books);
          
        } else {
          console.error("Failed to fetch books:", data.message);
        }
      } catch (error) {
        console.error("Error fetching books:", error);
      }
    };

    fetchBooks();
  }, [schoolId]);

  // Filter the issues based on book title and name
  const filteredData = data.filter(
    (item) =>
      (item.title.toLowerCase().includes(selectedBook.toLowerCase()) ||
        selectedBook === "") &&
      (item.member_name?.toLowerCase().includes(searchName.toLowerCase()) ||
        item.member_name?.toLowerCase().includes(searchName.toLowerCase()) ||
        searchName === "")
  );
  console.log("Filtered Data: ", filteredData);

  const totalPages = Math.ceil(filteredData.length / rowsPerPage);
  const currentData = filteredData.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
      console.log("Page changed to: ", page);
    }
  };

  const handleRowsPerPageChange = (e) => {
    setRowsPerPage(Number(e.target.value));
    setCurrentPage(1);
    console.log("Rows per page changed to: ", e.target.value);
  };

  const handleDelete = async () => {
    try {
      console.log("Deleting issue with ID: ", issueIdToDelete);
      const response = await axios.delete(deleteApiUrl, {
        data: {
          school_id: schoolId,
          issue_id: issueIdToDelete,
          user_id: sessionStorage.getItem("user_id"),
        },
      });

      console.log("Delete response: ", response);
      if (response.data.success) {
        setData(data.filter((item) => item.id !== issueIdToDelete));
        toast({
          title: "Success",
          description: "Book issue deleted successfully.",
          status: "success",
          duration: 3000,
          isClosable: true,
        });
        onClose();
      } else {
        console.error("Failed to delete book issue:", response.data.message);
        toast({
          title: "Error",
          description:
            response.data.message || "Failed to delete the book issue.",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
        onClose();
      }
    } catch (error) {
      console.error("Error deleting book issue:", error);
      toast({
        title: "Error",
        description: "An unexpected error occurred.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      onClose();
    }
  };

  return (
    <Box maxWidth="100%">
      <div className="teacher-list-container">
        <div
          className="header"
          style={{ display: "flex", alignItems: "center" }}
        >
          <h1 style={{ fontSize: "20px", margin: 0 }}>Return Book</h1>
          <div className="action-buttons" style={{ marginLeft: "auto" }}>
            <div className="export-dropdown">
              <Flex gap={2}>{/* <Fine_Modal /> */}</Flex>
            </div>
          </div>
        </div>

        <Box className="breadcrumb">
          <Link
            to="/admin"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <span>Dashboard</span>
          </Link>{" "}
          / <span>Library </span> /
          <Link
            to="/class/classlist"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <span>Return List</span>
          </Link>
        </Box>
      </div>
      <Box p={6} ml={1}>
        <Flex
          justify="space-between"
          align="center"
          className="sb"
          p={3}
          direction={{ base: "column", md: "row" }} // Stack on mobile, align horizontally on larger screens
        >
          {/* Rows per Page Section */}
          <Flex align="center" mb={{ base: 3, md: 0 }}>
            <Select
              width={{ base: "100%", md: "120px" }} // Full width on mobile, fixed width on larger screens
              value={rowsPerPage}
              onChange={handleRowsPerPageChange}
            >
              <option value={5}>5</option>
              <option value={10}>10</option>
              <option value={20}>20</option>
            </Select>
          </Flex>

          {/* Filter and Search Section */}
          <Flex
            direction={{ base: "column", md: "row" }} // Stack vertically on mobile, horizontally on larger screens
            gap={3}
            align={{ md: "center" }}
            justify={{ md: "flex-end" }} // Align items to the right on larger screens
            width={{ base: "100%", md: "auto" }} // Full width on mobile, shrink-to-fit on larger screens
          >
            <Select
              value={selectedBook}
              onChange={(e) => setSelectedBook(e.target.value)}
              placeholder="Filter by Book"
              width={{ base: "100%", md: "250px" }} // Full width on mobile, fixed width on larger screens
            >
              <option value="">All Books</option>
              {books.map((book) => (
                <option key={book.book_id} value={book.title}>
                  {book.title}
                </option>
              ))}
            </Select>
            <Input
              value={searchName}
              onChange={(e) => setSearchName(e.target.value)}
              placeholder="Search by Name"
              width={{ base: "100%", md: "250px" }} // Full width on mobile, fixed width on larger screens
            />
          </Flex>
        </Flex>

        <Box mb={1}>
          <Box overflowX="auto" maxWidth="100%">
            <Table  sx={{
                "tbody tr:nth-of-type(even)": { backgroundColor: "#f2f4f8" },
              }}>
              <Thead>
                <Tr>
                  <Th>Name</Th>
                  <Th>Book Title</Th>
                  <Th>Issue Date</Th>
                  <Th>Return Date</Th>
                  <Th>Status</Th>
                  <Th>Actions</Th>
                </Tr>
              </Thead>
              <Tbody>
                {currentData.map((row) => (
                  <Tr key={row.id}>
                    {/* <Td>
                      {row.student_name
                        ? row.student_name
                        : row.staff_name
                        ? row.staff_name
                        : "N/A"}
                    </Td> */}
                    <Td>{row.member_name}</Td>
                    <Td>{row.title}</Td>
                    <Td>{row.issue_date}</Td>
                    <Td>{row.return_date}</Td>
                    <Td>{row.status}</Td>
                    <Td>
                      <Stack direction="row" spacing={2}>
                        <IconButton
                          icon={<DeleteIcon />}
                          colorScheme="red"
                          size="sm"
                          onClick={() => {
                            setIssueIdToDelete(row.id);
                            onOpen();
                          }}
                        />
                      </Stack>
                    </Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </Box>

          <Flex justify="end" align="center" className="sb2" p={3}>
            <Button
              onClick={() => handlePageChange(currentPage - 1)}
              isDisabled={currentPage === 1}
            >
              Prev
            </Button>

            <Stack direction="row" spacing={2} mx={2}>
              {Array.from({ length: totalPages }, (_, i) => (
                <Button
                  key={i}
                  onClick={() => handlePageChange(i + 1)}
                  colorScheme={currentPage === i + 1 ? "teal" : "gray"}
                >
                  {i + 1}
                </Button>
              ))}
            </Stack>

            <Button
              onClick={() => handlePageChange(currentPage + 1)}
              isDisabled={currentPage === totalPages}
            >
              Next
            </Button>
          </Flex>

          {/* Delete Confirmation Modal */}
          <Modal isOpen={isOpen} onClose={onClose}>
            <ModalOverlay />
            <ModalContent>
              <ModalHeader>Delete Book Issue</ModalHeader>
              <ModalCloseButton />
              <ModalBody>
                <Text>Are you sure you want to delete this book issue?</Text>
              </ModalBody>
              <ModalFooter>
                <Button colorScheme="gray" mr={3} onClick={onClose}>
                  Cancel
                </Button>
                <Button colorScheme="red" onClick={handleDelete}>
                  Delete
                </Button>
              </ModalFooter>
            </ModalContent>
          </Modal>
        </Box>
      </Box>
    </Box>
  );
};

export default Return_Table;
